import { FormFieldDropdown as ChordsFormFieldDropdown } from '~/chords/FormField';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export const FormFieldDropdown = withClassNameHoc(ChordsFormFieldDropdown);
